import {
  COMPANY_TYPE_REQUEST,
  EXPERIENCED_AS_IN_TYPE_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_USER_REQUEST,
  LOGOUT_USER_DETAILS_REQUEST,
  LOGOUT_USER_DETAILS_SUCCESS,
  RESEND_OTP_REQUEST,
  SAVE_USER_DETAILS_REQUEST,
  SAVE_USER_DETAILS_SUCCESS,
  SET_NEW_PASSWORD_REQUEST,
  SET_NEW_PASSWORD_SUCCESS,
  VERIFY_OTP_REQUEST,
  VERIFY_USER_REQUEST,
} from "./login.type";

export const verifyUserRequest = (user, callback) => ({
  type: VERIFY_USER_REQUEST,
  payload: { user },
  callback,
});

export const resendOtpRequest = (user, callback) => ({
  type: RESEND_OTP_REQUEST,
  payload: { user },
  callback,
});

export const verifyOtpRequest = (user, otp, callback) => ({
  type: VERIFY_OTP_REQUEST,
  payload: { user, otp },
  callback,
});

export const saveUserRequest = (payload, callback) => ({
  type: SAVE_USER_DETAILS_REQUEST,
  payload,
  callback,
});
export const saveUserSuccess = (payload, callback) => ({
  type: SAVE_USER_DETAILS_SUCCESS,
  payload,
  callback,
});

export const logoutRequest = (payload, callback) => ({
  type: LOGOUT_USER_DETAILS_REQUEST,
  payload,
  callback,
});
export const logoutUserSuccess = (payload) => ({
  type: LOGOUT_USER_DETAILS_SUCCESS,
  payload,
});

export const getCompanyTypeRequest = (payload, callback) => ({
  type: COMPANY_TYPE_REQUEST,
  payload,
  callback,
});

export const getExprienceAsInTypeRequest = (payload, callback) => ({
  type: EXPERIENCED_AS_IN_TYPE_REQUEST,
  payload,
  callback,
});

export const loginUserRequest = (payload, callback) => ({
  type: LOGIN_USER_REQUEST,
  payload,
  callback,
});

export const loginSuccess = (data) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const setNewPasswordSuccess = (data) => ({
  type: SET_NEW_PASSWORD_SUCCESS,
  payload: data,
});


export const setNewPasswordRequest = (data, callback) => ({
  type: SET_NEW_PASSWORD_REQUEST,
  payload: data,
  callback,
});
